import React from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { withNamespace } from "components/Form/FormikControls/lib";
import { Row } from "components/Layout";
import { BuyerAwareBuyerWayField } from "components/Form/Fields";
import { FormikAwareBusinessPICSelector } from "components/Form/FormikControls/BusinessPICSelector";
import InlineConsignmentSelect from "components/SaleLotForms/InlineConsignmentSelect";

import { BUYER } from "constants/businesses";

import { getCurrentSaleyardId } from "selectors";

interface WhoTabProps {
  saleLotNamespace: string;
  onConsignmentChange?: (consignmentId: string) => void;
}

export const WhoTab = ({
  saleLotNamespace,
  onConsignmentChange,
}: WhoTabProps) => {
  const saleyardId = useSelector(getCurrentSaleyardId);

  return (
    <Grid item container xs={12}>
      <Row fullWidth marginVertical={2}>
        <InlineConsignmentSelect
          name={withNamespace(saleLotNamespace, "consignment_id")}
          label="Vendor"
          onChangeExtra={onConsignmentChange}
          showConsignmentCode={false}
          showAgencyName={false}
        />
      </Row>

      <Row fullWidth marginVertical={2}>
        <FormikAwareBusinessPICSelector
          label="Buyer"
          subLabel="Search by Business Name or PIC"
          businessFieldName={withNamespace(saleLotNamespace, "buyer_id")}
          propertyFieldName={withNamespace(
            saleLotNamespace,
            "destination_property_id",
          )}
          businessRoles={[BUYER]}
          labelFontSize="charlie"
          subLabelFontSize="beta"
        />
      </Row>

      <Row fullWidth marginVertical={2}>
        <BuyerAwareBuyerWayField
          name={withNamespace(saleLotNamespace, "buyer_way")}
          label="Buyer Way"
          buyerField={withNamespace(saleLotNamespace, "buyer_id")}
          saleyardId={saleyardId}
        />
      </Row>
    </Grid>
  );
};
